<section class="trp" data-testid="trace-panel">
  <button type="button" class="trp-toggle" data-testid="trace-toggle" [attr.aria-expanded]="expanded" (click)="toggle()">
    <span class="trp-title">{{ 'trace.title' | transloco }}</span>
    <span class="trp-action">{{ (expanded ? 'trace.collapse' : 'trace.expand') | transloco }}</span>
  </button>

  <div class="trp-body" *ngIf="expanded">
    <p class="trp-muted" data-testid="trace-loading" *ngIf="loading">{{ 'trace.loading' | transloco }}</p>
    <p class="trp-error" data-testid="trace-error" *ngIf="errorMessage">{{ errorMessage }}</p>

    <ng-container *ngIf="trace">
      <div class="trp-head">
        <strong data-testid="trace-subject">{{ trace.subject }}</strong>
        <span class="trp-actions">
          <span class="trp-muted" data-testid="trace-copy-status" *ngIf="copyState !== 'idle'">{{ (copyState === 'copied' ? 'trace.copied' : 'trace.copyFailed') | transloco }}</span>
          <button type="button" class="trp-copy" data-testid="trace-copy" (click)="copy()">{{ 'trace.copy' | transloco }}</button>
        </span>
      </div>

      <ol class="trp-steps" data-testid="trace-steps">
        <li class="trp-step" data-testid="trace-step" *ngFor="let step of trace.steps; let i = index" [attr.data-step-key]="step.key">
          <div class="trp-step-head">
            <span class="trp-chip">{{ 'trace.stepNumber' | transloco: { n: i + 1 } }}</span>
            <span class="trp-label" data-testid="trace-label">{{ step.label }}</span>
          </div>
          <code class="trp-code" data-testid="trace-formula">{{ step.formula }}</code>
          <code class="trp-code trp-code-numbers" data-testid="trace-substituted">{{ step.substituted }}</code>
          <div class="trp-result" data-testid="trace-result">= {{ step.result }} {{ step.unit }}</div>
          <div class="trp-note" data-testid="trace-note" *ngIf="step.note">{{ step.note }}</div>
          <details class="trp-inputs" *ngIf="step.inputs.length">
            <summary>{{ 'trace.inputs' | transloco }}</summary>
            <ul>
              <li *ngFor="let input of step.inputs">{{ input.name }} = {{ input.value }} <small>({{ input.source }})</small></li>
            </ul>
          </details>
        </li>
      </ol>
    </ng-container>
  </div>
</section>
